import React, { useState } from "react";
import { Accordion, Card, Button } from "react-bootstrap";
// import carta from "../../../images/carta.jpeg";
import comunicacion from "../../../images/comunicacion.png";

const EjemploCartaComponent = () => {
  const [ClickCarta, setClickCarta] = useState(false);
  return (
    <Accordion className="col-12 p-0 m-0" defaultActiveKey="0">
      <Card className="bg-ejemplo-ss">
        <Card.Header className="bg-ejemplo-ss text-center">
          <Accordion.Toggle
            as={Button}
            variant="link"
            eventKey="0"
            className="font-primary-ss font-weight-bold text-center "
            onClick={() => setClickCarta(!ClickCarta)}
          >
            Ver ejemplo de comunicación de adecuación{" "}
            <i
              className={`mr-2 fas ${
                ClickCarta === false ? "fa-arrow-up" : "fa-arrow-down"
              }`}
            ></i>
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body style={{padding: 0}}>
     
            <p className="text-justify">
              Asegúrese que su nombre en el encabezado de la comunicación enviada por la Isapre esté claro y sea el suyo, 
              que se refiera al reajuste del precio o prima GES y que el contenido esté legible al momentos de subir el archivo. 
              En caso contrario, el documento será rechazado.
            </p>

            <img
              src={comunicacion}
              alt="Comunicación Adecuación"
              className="img-fluid d-flex mx-auto"
              style={{border: "3px solid lightgray", borderRadius: "5px"}}
            />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default EjemploCartaComponent;
